<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. قسم التحكم والفلاتر (لا يظهر في الطباعة) -->
    <div class="card shadow-sm mb-4 no-print border-top-primary">
      <div class="card-header bg-white">
        <h5 class="mb-0 text-primary fw-bold"><i class="fas fa-print ms-2"></i> طباعة كشوف المراجعة (المرآة)</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label fw-bold">الفصل الدراسي</label>
            <select v-model="form.term" @change="getSubjectswithtearm(form.term)" class="form-select">
              <option value="">-- اختر الفصل --</option>
              <option v-for="t in terms" :key="t.id" :value="t">{{ t.name }}</option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-bold">المادة</label>
            <select v-model="form.subject" class="form-select">
              <option value="">-- اختر المادة --</option>
              <option v-for="s in subjects" :key="s.id" :value="s">{{ s.name }}</option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-bold">المجموعة</label>
            <select v-model="form.group" class="form-select">
              <option value="">-- اختر المجموعة --</option>
              <option v-for="g in groups" :key="g.id" :value="g.id">{{ g.group_name }}</option>
            </select>
          </div>
        </div>

        <div class="d-flex gap-2 mt-4 pt-3 border-top">
          <button @click="getResults(false)" class="btn btn-primary px-4" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm ms-1"></span>
            <i class="fas fa-search ms-1"></i> عرض المراجعة (أولى)
          </button>
          
          <button @click="getResults(true)" class="btn btn-outline-primary px-4" :disabled="loading">
            <i class="fas fa-search-plus ms-1"></i> عرض المراجعة (ثانية/نهائية)
          </button>

          <button @click="print" class="btn btn-dark px-4 ms-auto" :disabled="collection.length === 0">
            <i class="fas fa-print ms-1"></i> طباعة الكشف
          </button>
        </div>
      </div>
    </div>

    <!-- 2. منطقة عرض الكشوف (الطباعة) -->
    <div id="printMe" v-if="collection.length > 0">
      
      <!-- حلقة تكرار لكل 50 طالب (صفحة جديدة) -->
      <div 
        v-for="(chunkGroup, chunkIndex) in chunkedCollection" 
        :key="'page-' + chunkIndex" 
        class="print-page"
      >
        
        <!-- ترويسة الصفحة -->
        <header class="page-header mb-2 border-bottom border-2 border-dark pb-2">
          <div class="d-flex justify-content-between align-items-center text-center">
            <div style="width: 30%">
              <h6 class="mb-1 fw-bold">مديرية التربية والتعليم</h6>
              <h6 class="mb-0 fw-bold">لجنة النظام والمراقبة</h6>
            </div>
            
            <div style="width: 40%">
              <h3 class="fw-bold text-decoration-underline mb-1">كشف مراجعة رصد</h3>
              <h5 class="fw-bold m-0">مادة: {{ form.subject?.name }}</h5>
            </div>

            <div style="width: 30%" class="text-start ps-3">
              <div class="border border-dark p-1 d-inline-block text-center" style="min-width: 120px;">
                <small class="d-block text-muted">نوع المراجعة</small>
                <strong class="fs-5">{{ label }}</strong>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between mt-2 px-2 bg-light border border-dark">
            <span class="fw-bold fs-5">مجموعة رقم: ( {{ form.group }} )</span>
            <span class="fw-bold fs-5">مظروف رقم: ( {{ chunkIndex + 1 }} )</span>
            <span class="fw-bold fs-5">عدد الأوراق: {{ chunkGroup.length }}</span>
          </div>
        </header>

        <!-- جسم الصفحة (جدولين متجاورين) -->
        <div class="page-body d-flex gap-4">
          
          <!-- العمود الأول (25 طالب) -->
          <div class="flex-fill">
            <table class="table table-bordered border-dark text-center align-middle mb-0 compact-table">
              <thead class="table-dark text-white">
                <tr>
                  <th width="40%">الرقم السري</th>
                  <th width="35%">الدرجة</th>
                  <th width="25%">التعديل</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="student in chunkGroup.slice(0, 25)" :key="student.SecretKey">
                  <td class="fw-bold font-monospace fs-5 bg-light">{{ student.SecretKey | scur }}</td>
                  <td class="fw-bold fs-4" :class="{'bg-secondary text-white': isAbsent(student)}">
                    {{ formatDegree(student.subject) }}
                  </td>
                  <td></td> <!-- خانة فارغة للتعديل اليدوي -->
                </tr>
                <!-- إكمال الصفوف الفارغة للحفاظ على التنسيق إذا كان العدد أقل من 25 -->
                <tr v-for="n in (25 - chunkGroup.slice(0, 25).length)" :key="'empty-1-'+n">
                  <td>&nbsp;</td><td></td><td></td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- خط فاصل (اختياري) -->
          <div class="vr" style="width: 2px; background: #000; opacity: 1;"></div>

          <!-- العمود الثاني (25 طالب) -->
          <div class="flex-fill">
            <table class="table table-bordered border-dark text-center align-middle mb-0 compact-table">
              <thead class="table-dark text-white">
                <tr>
                  <th width="40%">الرقم السري</th>
                  <th width="35%">الدرجة</th>
                  <th width="25%">التعديل</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="student in chunkGroup.slice(25, 50)" :key="student.SecretKey">
                  <td class="fw-bold font-monospace fs-5 bg-light">{{ student.SecretKey | scur }}</td>
                  <td class="fw-bold fs-4" :class="{'bg-secondary text-white': isAbsent(student)}">
                    {{ formatDegree(student.subject) }}
                  </td>
                  <td></td>
                </tr>
                 <!-- إكمال الصفوف الفارغة -->
                 <tr v-for="n in (25 - chunkGroup.slice(25, 50).length)" :key="'empty-2-'+n">
                  <td>&nbsp;</td><td></td><td></td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>

        <!-- تذييل الصفحة -->
        <footer class="page-footer mt-2 pt-2 border-top border-2 border-dark">
          <div class="row text-center fs-5 fw-bold">
            <div class="col-4">
              <p class="mb-1 text-muted fs-6">الراصد</p>
              <p class="mb-0">....................</p>
            </div>
            <div class="col-4">
              <p class="mb-1 text-muted fs-6">المراجع</p>
              <p class="mb-0">....................</p>
            </div>
            <div class="col-4">
              <p class="mb-1 text-muted fs-6">رئيس الحجرة</p>
              <p class="mb-0">....................</p>
            </div>
          </div>
        </footer>

        <!-- فاصل صفحات للطباعة -->
        <div class="page-break"></div>

      </div>
    </div>

    <!-- رسالة فارغة -->
    <div v-else-if="searched" class="alert alert-warning text-center mt-5 no-print">
      لا توجد بيانات للعرض، يرجى التأكد من الاختيارات.
    </div>

  </div>
</template>

<script>
import api from "../../api/axios";
import _ from "lodash";

export default {
  name: "ReviewGradeSheet",
  data() {
    return {
      loading: false,
      searched: false,
      label: "أولى", // نوع المراجعة
      groups: [],
      subjects: [],
      terms: [],
      collection: [],
      form: {
        term: "",
        subject: "",
        group: "",
      },
    };
  },
  computed: {
    // تقسيم البيانات إلى صفحات (كل صفحة 50 طالب)
    chunkedCollection() {
      return _.chunk(this.collection, 50);
    }
  },
  filters: {
    scur(val) {
        if(!val) return '';
        // يمكن إضافة منطق لإخفاء جزء من السري هنا إذا أردت
        return val;
    }
  },
  mounted() {
    this.fetchInitData();
  },
  methods: {
    async fetchInitData() {
        try {
            const [termsRes, groupsRes] = await Promise.all([
                api.get("/getterms"),
                api.get("/getgroups")
            ]);
            this.terms = termsRes.data;
            this.groups = groupsRes.data;
        } catch(e) { console.error(e); }
    },

    getSubjectswithtearm(term) {
      if(!term) return;
      api.get("/getSubject/" + term.id).then((res) => {
        this.subjects = res.data;
      });
    },

    async getResults(isFinal = false) {
      if(!this.form.term || !this.form.subject || !this.form.group) {
          alert('يرجى اختيار جميع الحقول');
          return;
      }

      this.loading = true;
      this.searched = true;
      this.label = isFinal ? "نهائية" : "أولى";
      const endpoint = isFinal ? "/checkDegreeStudent" : "/checkDegreeStudent";

      try {
        const res = await api.get(endpoint, {
          params: {
            term: this.form.term,
            subject: this.form.subject,
            group: this.form.group,
          },
        });
        this.collection = res.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    // دالة لتنسيق الدرجة (تحويل -1 إلى غ)
    formatDegree(val) {
        if (val == '-1' || val == -1) return 'غ';
        return val;
    },
    
    // فحص الغياب للتلوين
    isAbsent(student) {
        return student.subject == '-1';
    },

    print() {
      this.$htmlToPaper("printMe");
    },
  },
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }

/* === تنسيقات الطباعة === */
@media print {
  @page {
    size: A4 portrait;
    margin: 10mm 10mm 5mm 10mm; /* هوامش ضيقة لاستغلال المساحة */
  }

  body * {
    visibility: hidden;
  }
  
  .no-print {
    display: none !important;
  }

  #printMe, #printMe * {
    visibility: visible;
  }

  #printMe {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  /* تنسيق الصفحة الواحدة */
  .print-page {
    page-break-after: always;
    page-break-inside: avoid;
    height: 98vh; /* ملء الصفحة تقريباً */
    display: flex;
    flex-direction: column;
  }

  /* تنسيق الجدول */
  .compact-table th, .compact-table td {
    border: 1px solid #000 !important;
    padding: 2px 5px !important; /* تقليل الحواف الداخلية */
    font-size: 16pt !important; /* خط كبير وواضح */
    height: 35px; /* ارتفاع ثابت للصف */
  }
  
  .table-dark {
      background-color: #333 !important;
      color: white !important;
      -webkit-print-color-adjust: exact;
  }

  /* خلفية الغياب */
  .bg-secondary {
      background-color: #888 !important;
      color: white !important;
      -webkit-print-color-adjust: exact;
  }
}
</style>